import Image, { ImageProps } from "next/legacy/image";
import { InferGetStaticPropsType } from 'next';
import { getStaticProps } from '@/src/pages/knowledge/blog/[slug]';
import { authorPath } from '@/src/paths';
import xIcon from '@/public/images/x.svg';
import facebookIcon from '@/public/images/facebook.svg';
import instagramIcon from '@/public/images/instagram.png';
import linkedInIcon from '@/public/images/linkedin.png';
import myspaceIcon from '@/public/images/myspace.svg';
import pinterestIcon from '@/public/images/pinterest.png';
import soundCloudIcon from '@/public/images/soundcloud.svg';
import youtubeIcon from '@/public/images/youtube.png';
import wikipediaIcon from '@/public/images/wikipedia.png';

const Sns: React.FC<{
  imgSrc: ImageProps['src'];
  alt?: string;
  url?: string | null;
}> = ({ imgSrc, alt, url }) =>
  url ? (
    <a href={url} target='_blank' className='hover:opacity-75'>
      <Image
        src={imgSrc}
        width={30}
        height={30}
        alt={alt || ''}
        objectFit='contain'
      />
    </a>
  ) : null;

export const Author: React.FC<{
  author: InferGetStaticPropsType<typeof getStaticProps>['post']['author'];
}> = ({ author }) => {
  const node = author?.node;

  if (!node) {
    return null;
  }

  return (
    <>
      <div className='mt-8 mb-4 text-xl font-bold md:text-2xl'>著者情報</div>
      <div className='flex flex-col rounded-lg border border-top-primary py-8 px-8 md:flex-row md:px-12'>
        {node.avatar?.url && (
          <div className='mx-auto mb-8 flex shrink-0 items-center md:mb-0 md:mr-12'>
            <a href={authorPath(node.databaseId)} className='hover:opacity-75'>
              <Image
                src={node.avatar.url}
                width={node.avatar.width || 144}
                height={node.avatar.height || 144}
                objectFit='scale-down'
                alt=''
              />
            </a>
          </div>
        )}
        <div className='flex grow flex-col justify-between'>
          <div>
            <div className='mb-4 '>
              <a
                href={authorPath(node.databaseId)}
                className='font-bold text-primary hover:opacity-75'
              >
                {node.companyName ? `${node.companyName}　` : ''}
                {node.name}
              </a>
            </div>
            <div className='whitespace-pre-wrap'>{node.description}</div>
          </div>
          <div className='mt-6 flex flex-wrap gap-1 md:ml-auto'>
            <Sns
              url={node.seo?.social?.facebook}
              imgSrc={facebookIcon}
              alt='Facebook'
            />
            <Sns
              url={node.seo?.social?.pinterest}
              imgSrc={pinterestIcon}
              alt='Pinterest'
            />
            <Sns
              url={
                node.seo?.social?.twitter
                  ? `https://x.com/${node.seo?.social?.twitter}`
                  : null
              }
              imgSrc={xIcon}
              alt='X'
            />
            <Sns
              url={node.seo?.social?.instagram}
              imgSrc={instagramIcon}
              alt='Instagram'
            />
            <Sns
              url={node.seo?.social?.wikipedia}
              imgSrc={wikipediaIcon}
              alt='Wikipedia'
            />
            <Sns
              url={node.seo?.social?.youTube}
              imgSrc={youtubeIcon}
              alt='YouTube'
            />
            <Sns
              url={node.seo?.social?.linkedIn}
              imgSrc={linkedInIcon}
              alt='LinkedIn'
            />
            <Sns
              url={node.seo?.social?.mySpace}
              imgSrc={myspaceIcon}
              alt='MySpace'
            />
            <Sns
              url={node.seo?.social?.soundCloud}
              imgSrc={soundCloudIcon}
              alt='SoundCloud'
            />
          </div>
        </div>
      </div>
    </>
  );
};
